import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e90edc4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column-cell" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-d-flex p-justify-between p-ai-center" }
const _hoisted_4 = {
  key: 0,
  class: "icon-error p-ml-2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-alert-outline" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "column-cell"
}
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.clickOnTestingButton)
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: 0,
        class: "p-component p-shadow-2",
        value: _ctx.fieldTestingValues,
        autoLayout: true,
        loading: _ctx.loading,
        selection: _ctx.selection,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selection) = $event)),
        selectionMode: "single",
        onRowSelect: _ctx.onRowSelect
      }, {
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.Validation.General.Position') })), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            headerClass: "header-center",
            style: {"width":"3rem","text-align":"center"}
          }),
          _createVNode(_component_Column, {
            field: "fieldName",
            header: _ctx.$t('Squeeze.DocumentClasses.Field')
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "keyWord.value",
            header: _ctx.$t('Squeeze.Training.Anchor'),
            style: {"min-width":"10rem"}
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "value.value",
            header: _ctx.$t('Squeeze.Locators.Value'),
            style: {"min-width":"7rem"}
          }, {
            body: _withCtx((slotProps) => [
              (!slotProps.data.value.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" - ")
                  ], 64))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createTextVNode(_toDisplayString(slotProps.data.value.value), 1)
              ])), [
                [
                  _directive_tooltip,
                  slotProps.data.value.value,
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, { style: {"min-width":"7rem","max-width":"7rem","text-align":"right"} }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.dataType === 'Amount' || slotProps.data.dataType === 'Date')
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_Button, {
                      icon: "mdi mdi-pencil-outline",
                      disabled: true,
                      class: "p-button p-component p-button-icon-only p-button-rounded p-button-success p-button-text"
                    })
                  ])), [
                    [_directive_tooltip, _ctx.$t('Squeeze.Training.EditButtonDisabled')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "mdi mdi-pencil-outline",
                    class: "p-button p-component p-button-icon-only p-button-rounded p-button-success p-button-text",
                    onClick: ($event: any) => (_ctx.changeTrainingRow(slotProps.data))
                  }, null, 8, ["onClick"])), [
                    [_directive_tooltip, _ctx.$t('Squeeze.Locators.Edit')]
                  ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "mdi mdi-delete-outline",
                class: "p-button p-button-rounded p-button-danger p-button-text deleteButtonRow",
                onClick: ($event: any) => (_ctx.deleteTrainingRow(slotProps.data))
              }, null, 8, ["onClick"]), [
                [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.Delete')]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "selection", "onRowSelect"]))
    : (_openBlock(), _createBlock(_component_DataTable, {
        key: 1,
        class: "p-component p-shadow-2",
        value: _ctx.tableTrainingValues,
        autoLayout: true,
        rowHover: true,
        loading: _ctx.loading
      }, {
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.Validation.General.Position') })), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "id",
            header: "ID",
            headerClass: "header-center",
            style: {"width":"3rem","text-align":"center"}
          }),
          _createVNode(_component_Column, {
            field: "fieldName",
            header: _ctx.$t('Squeeze.DocumentClasses.Field')
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(slotProps.data.fieldName), 1),
                (_ctx.checkIfFieldIsNotTrainable(slotProps.data.fieldName))
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6)), [
                      [_directive_tooltip, _ctx.$t('Squeeze.Training.NotTrainable', { fieldName: slotProps.data.fieldName})]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "keyWordPattern",
            header: _ctx.$t('Squeeze.Training.Anchor')
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "valuePattern",
            header: _ctx.$t('Squeeze.Locators.Value'),
            style: {"min-width":"10rem"}
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "replaceValue",
            header: _ctx.$t('Squeeze.Training.ResultValue'),
            style: {"min-width":"10rem","max-width":"10rem"}
          }, {
            body: _withCtx((slotProps) => [
              (!slotProps.data.replaceValue)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" - ")
                  ], 64))
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(slotProps.data.replaceValue), 1)
                  ])), [
                    [
                      _directive_tooltip,
                      slotProps.data.replaceValue,
                      void 0,
                      { bottom: true }
                    ]
                  ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, { style: {"min-width":"7rem","max-width":"7rem","text-align":"right"} }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.dataType === 'Amount' || slotProps.data.dataType === 'Date')
                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(_component_Button, {
                      disabled: true,
                      icon: "mdi mdi-pencil-outline",
                      class: "p-button p-component p-button-icon-only p-button-rounded p-button-success p-button-text"
                    })
                  ])), [
                    [_directive_tooltip, _ctx.$t('Squeeze.Training.EditButtonDisabled')]
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "mdi mdi-pencil-outline",
                    class: "p-button p-component p-button-icon-only p-button-rounded p-button-success p-button-text",
                    onClick: ($event: any) => (_ctx.changeTrainingRow(slotProps.data))
                  }, null, 8, ["onClick"])), [
                    [_directive_tooltip, _ctx.$t('Squeeze.Locators.Edit')]
                  ]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "mdi mdi-delete-outline",
                class: "p-button p-button-rounded p-button-danger p-button-text deleteButtonRow",
                onClick: ($event: any) => (_ctx.deleteTrainingRow(slotProps.data))
              }, null, 8, ["onClick"]), [
                [_directive_tooltip, _ctx.$t('Squeeze.Validation.Buttons.Delete')]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"]))
}